import { getApiBaseUrl, apiRequest } from './apiClient';

export const TS_KAYIT_BASVURU_SAYAC_YENILE_EVENT = 'hlm-ts-kayit-basvuru-sayac-yenile';

const publicBase = () => `${getApiBaseUrl()}/api/public/ts-kayit`;

/** 429/502 gibi JSON olmayan yanıtlarda da okunur bir hata mesajı üretir */
async function readJsonSafe(res) {
  try {
    return await res.json();
  } catch {
    if (res.status === 429) return { mesaj: 'Çok fazla istek yapıldı. Lütfen birkaç dakika sonra tekrar deneyin.' };
    if (res.status >= 500) return { mesaj: 'Sunucuya şu an ulaşılamıyor. Lütfen biraz sonra tekrar deneyin.' };
    return {};
  }
}

async function publicFetch(url, options, varsayilanHata) {
  let res;
  try {
    res = await fetch(url, options);
  } catch {
    throw new Error('İnternet bağlantınızı kontrol edip tekrar deneyin.');
  }
  const json = await readJsonSafe(res);
  if (!res.ok) {
    const err = new Error(json.mesaj || varsayilanHata);
    err.status = res.status;
    throw err;
  }
  return json;
}

export const fetchTsKayitForm = (token) =>
  publicFetch(`${publicBase()}/${encodeURIComponent(token)}`, undefined, 'Form yüklenemedi');

export const checkTsKayitKullaniciAdi = (token, kullaniciAdi) =>
  publicFetch(
    `${publicBase()}/${encodeURIComponent(token)}/kullanici-adi?k=${encodeURIComponent(kullaniciAdi)}`,
    undefined,
    'Kontrol yapılamadı',
  );

/** arama boş bırakılırsa tüm uygun servisler döner */
export const searchTsKayitTeknikServisler = (token, arama = '') =>
  publicFetch(
    `${publicBase()}/${encodeURIComponent(token)}/teknik-servisler?arama=${encodeURIComponent(arama)}`,
    undefined,
    'Servis listesi yüklenemedi',
  );

export const submitTsKayitBasvuru = (token, payload) =>
  publicFetch(
    `${publicBase()}/${encodeURIComponent(token)}/gonder`,
    { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) },
    'Başvuru gönderilemedi',
  );

export const sendTsKayitNot = (token, payload) =>
  publicFetch(
    `${publicBase()}/${encodeURIComponent(token)}/not`,
    { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) },
    'Mesaj gönderilemedi',
  );

export const fetchTsKayitOturum = (token, basvuruId) => {
  const params = new URLSearchParams({ basvuruId: String(basvuruId) });
  return publicFetch(
    `${publicBase()}/${encodeURIComponent(token)}/oturum?${params.toString()}`,
    undefined,
    'Oturum yüklenemedi',
  );
};

export const createTsKayitDavet = async () => {
  return apiRequest('/api/ts-kayit-basvurulari/davet', { method: 'POST' });
};

export const pasifAlTsKayitDavet = async (id) => {
  return apiRequest(`/api/ts-kayit-basvurulari/davet/${encodeURIComponent(id)}/pasif`, {
    method: 'POST',
  });
};

export const fetchTsKayitGecerlilikSecenekleri = async () => {
  return apiRequest('/api/ts-kayit-basvurulari/davet/gecerlilik-secenekleri', { method: 'GET' });
};

export const updateTsKayitDavetGecerlilik = async (id, sureMs) => {
  return apiRequest(`/api/ts-kayit-basvurulari/davet/${encodeURIComponent(id)}/gecerlilik`, {
    method: 'PATCH',
    body: { sureMs },
  });
};

export const fetchTsKayitBasvurulari = async ({ sekme = 'onay_bekliyor', sayfa = 1, limit = 20 } = {}) => {
  const params = new URLSearchParams({
    sekme,
    sayfa: String(sayfa),
    limit: String(limit),
  });
  return apiRequest(`/api/ts-kayit-basvurulari?${params.toString()}`, { method: 'GET' });
};

export const fetchTsKayitBasvuruDetay = async (id) => {
  return apiRequest(`/api/ts-kayit-basvurulari/${encodeURIComponent(id)}`, { method: 'GET' });
};

export const fetchTsKayitBasvuruSekmeSayilari = async () => {
  return apiRequest('/api/ts-kayit-basvurulari/sekme-sayilari', { method: 'GET' });
};

export const onaylaTsKayitBasvuru = async (id) => {
  const res = await apiRequest(`/api/ts-kayit-basvurulari/${encodeURIComponent(id)}/onayla`, {
    method: 'POST',
  });
  window.dispatchEvent(new CustomEvent(TS_KAYIT_BASVURU_SAYAC_YENILE_EVENT));
  return res;
};

export const reddetTsKayitBasvuru = async (id, redNedeni) => {
  const res = await apiRequest(`/api/ts-kayit-basvurulari/${encodeURIComponent(id)}/reddet`, {
    method: 'POST',
    body: { redNedeni },
  });
  window.dispatchEvent(new CustomEvent(TS_KAYIT_BASVURU_SAYAC_YENILE_EVENT));
  return res;
};

export const refreshTsKayitBasvuruSayac = () => {
  window.dispatchEvent(new CustomEvent(TS_KAYIT_BASVURU_SAYAC_YENILE_EVENT));
};

export const fetchTsKayitNotlar = async ({ sayfa = 1, limit = 20, filtre = 'tumu' } = {}) => {
  const params = new URLSearchParams({ sayfa: String(sayfa), limit: String(limit), filtre });
  return apiRequest(`/api/ts-kayit-basvurulari/notlar?${params.toString()}`, { method: 'GET' });
};

export const isaretleTsKayitNot = async (id, okundu = true) => {
  const res = await apiRequest(`/api/ts-kayit-basvurulari/notlar/${encodeURIComponent(id)}/okundu`, {
    method: 'PATCH',
    body: { okundu },
  });
  window.dispatchEvent(new CustomEvent(TS_KAYIT_BASVURU_SAYAC_YENILE_EVENT));
  return res;
};
